//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import util from '@/javascript/util'
    import Cpts020 from '@/components/lyx-components/cpts020/index.vue'

    export default {
        components: {
            Cpts020
        },
        data() {
            return {
                minHeight: "",
                params: JSON.parse(sessionStorage.getItem('historyData')),
                scenicSpots: JSON.parse(sessionStorage.getItem('historyData')).scenicSpots ? JSON.parse(sessionStorage.getItem('historyData')).scenicSpots : [],
                chooseList: [],
                tabsListPageNo: 1,
                tabsListPageSize: 15,
                infiniteStatus: false,
                infiniteAll: false,
                addList:[],
                tags: [],
                scienceLever: [{
                    code: 102001,
                    name: '非A级'
                }, {
                    code: 102002,
                    name: 'A'
                }, {
                    code: 102003,
                    name: 'AA'
                }, {
                    code: 102004,
                    name: 'AAA'
                }, {
                    code: 102005,
                    name: 'AAAA'
                }, {
                    code: 102006,
                    name: 'AAAAA'
                }]
            };
        },
        mounted() {
            this.minHeight = document.documentElement.clientHeight;

            document.title = this.PAGE_TITLE + '选择景点'

            if(this.params !== null){
                this.tags = JSON.parse(sessionStorage.getItem('historyData')).tags
            }

            this.init()

            /**
             * 底部加载
             */
            window.addEventListener('scroll', () => {
                if (util.pullUpLoad() && this.chooseList.length > 0) {
                    this.infinite()
                }
            })
            
        },
        methods: {
            init(){
                this.$http.get('api/wtcp-recommend/public/scenicSpot/selectByTravelerIntent?deleted=0&page='+ this.tabsListPageNo + '&size=' + this.tabsListPageSize + '&code=' + this.$route.params.cityId + "&types=" + this.tags).then((response) => {

                    const list = response.data.data.records  ?  response.data.data.records : [] 
                    const listSpot = list.map(scenic => {
                        this.scienceLever.map(item => {
                            if (scenic.level == item.code) {
                                scenic.level = item.name
                            }
                        })
                        return scenic
                    })
                    this.chooseList = this.chooseList.concat(listSpot)
                    if (response.data.data.records.length < this.tabsListPageSize) {
                        this.infiniteAll = true
                    }
                    this.infiniteStatus = false

                }).then(() => {

                    for(let i=0;i<this.chooseList.length;i++){
                        for(let j=0;j<this.scenicSpots.length;j++){
                            if(this.chooseList[i].id == this.scenicSpots[j].id){
                                this.$set(this.chooseList[i], 'value', true)
                                this.addList.push(this.chooseList[i])
                                this.scenicSpots.splice(j,1)
                            }
                        }
                    }
                })
            },
            infinite: function () {
                if (this.infiniteAll) {
                    return
                }
                if (this.infiniteStatus) {
                    return
                }

                this.infiniteStatus = true
                this.tabsListPageNo += 1
                this.init()
            },
            scenicSpot(item){
                if (item.value) {
                    this.$set(item, 'value', false)
                    for(let k=0;k<this.addList.length;k++){
                        if(item.id == this.addList[k].id){
                            this.addList.splice(k,1)
                        }
                    }
                } else {
                    this.$set(item, 'value', true)
                    this.addList.push(item)
                }
            },
            nextTip(){

                const scenicIds = this.addList.map(item => {
                    return item.id
                })
                const residue = this.scenicSpots.map(item => {
                    return item.id
                })
                this.params['scenicIds'] = residue.concat(scenicIds)
                this.params['scenicSpots'] = this.scenicSpots.concat(this.addList)

                sessionStorage.setItem('historyData', JSON.stringify(this.params))

                this.$router.replace({path: '/choose-spot'})
            }
        }
    };
